/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "./MasterRunninghrs.css";
import {
  Table,
  Pagination,
  Button,
  Input,
  InputGroup,
  Modal,
  Form,
  SelectPicker,
  CheckTreePicker,
  Uploader,
  Textarea,
  DateRangePicker,
  DatePicker,
  Stack,
  IconButton,
} from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import PlusIcon from "@rsuite/icons/Plus";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";
import Header from "../../commonComponents/Header";
import {
  ErrorNotify,
  SuccessNotify,
} from "../../commonComponents/ToastMessage";

import useAuth from "../../hooks/useAuth";
import { ToastContainer } from "react-toastify";
import ShowLoader from "../../commonComponents/ShowLoader";
import moment from "moment";
import * as XLSX from "xlsx";
import StatsCard from "../DashBoard/StatsCard";
import {
  DeleteApi,
  DownloadFiles,
  FormDataPostApi,
  GetApi,
  PostApi,
  UpdateApi,
} from "../../services/ApiService";
import { FormatKey, GetCurrentShift } from "../../Utils";
import { GoTrash } from "react-icons/go";
import { FiUploadCloud } from "react-icons/fi";

const { Column, HeaderCell, Cell } = Table;

const MasterRunninghrs = () => {
  const { auth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [formData, setFormData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [createMode, setCreateMode] = useState("form"); // "form" | "upload"
  const [formErrors, setFormErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [uploadingList, setUploadingList] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [dropDownEquipmentData, setDropDownEquipmentData] = useState([]);

  useEffect(() => {
    GetEquipments();
    GetEngineRuntimeData(searchKeyword, 1);
  }, []);

  const handleSortColumn = (sortColumn, sortType) => {
    setSortColumn(sortColumn);
    setSortType(sortType);
  };

  // Form Validation errors
  const validate = (data) => {
    const errors = {};
    const { equipment_id, meter_hours, reason } = data;

    if (!equipment_id)
      errors.equipment_id = "Please select at least one equipment.";

    if (!meter_hours) {
      errors.meter_hours = "Please fill the meter engine runtime";
    }
    if (!reason) {
      errors.reason = "Please fill the reason";
    }
    return errors;
  };

  const clearError = (field) => {
    setFormErrors((prev) => ({
      ...prev,
      [field]: undefined,
    }));
  };

  const handleChange = (name, value) => {
    const updatedData = { ...formData, [name]: value };
    setFormData(updatedData);

    let errors = {};

    setFormErrors((prev) => ({
      ...prev,
      ...errors,
      [name]: errors[name] || undefined,
    }));
  };

  const handleAddNew = () => {
    setFormData({});
    setUploadingList([]);
    setFormErrors({});
    setCreateMode("form");
    setShowForm(true);
  };

  const handleSubmit = () => {
    const errors = validate(formData);
    setFormErrors(errors);

    if (Object.keys(errors).length !== 0) {
      ErrorNotify("Please fix the highlighted errors before submitting.");
      return;
    }

    const bodyRequest = {
      client_id: auth.clientId,
      equnr: formData.equipment_id,
      meter_hours: formData.meter_hours,
      reason: formData.reason,
    };
    setShowLoader(true);
    if (formData.form_id) {
      UpdateMeterHours(bodyRequest);
    } else {
      CreateMeterHours(bodyRequest);
    }
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  };

  const filteredData = () => {
    const sortedData = [...tableData];
    if (sortColumn && sortType) {
      sortedData.sort((a, b) => {
        let x = getNestedValue(a, sortColumn);
        let y = getNestedValue(b, sortColumn);

        // handle null values
        x = x ?? "";
        y = y ?? "";

        // date columns
        if (sortColumn === "created_at" || sortColumn === "updated_at") {
          x = x ? new Date(...x.split("/").reverse()) : new Date(0);
          y = y ? new Date(...y.split("/").reverse()) : new Date(0);
        } else if (!isNaN(x) && !isNaN(y) && x !== "" && y !== "") {
          x = Number(x);
          y = Number(y);
        }

        // string sorting
        if (typeof x === "string") x = x.toLowerCase();
        if (typeof y === "string") y = y.toLowerCase();

        if (x > y) return sortType === "asc" ? 1 : -1;
        if (x < y) return sortType === "asc" ? -1 : 1;

        return 0;
      });
    }
    return sortedData;
  };

  const GetEngineRuntimeData = (search, page) => {
    GetApi(
      `equipment/hour-meter-counter?search=${search}&page=${page}&limit=${limit}`,
      auth.accessToken,
    )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setTableData(res.data.counters);
          setTotalCount(res.data.total);
          setLoading(false);
          setShowLoader(false);
        } else {
          ErrorNotify(res.message);
          setTableData([]);
          setTotalCount(0);
          setLoading(false);
          setShowLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setTableData([]);
        setTotalCount(0);
        setLoading(false);
        setShowLoader(false);
      });
  };

  // Get Equipments for Equipment Master
  const GetEquipments = () => {
    GetApi(
      `equipment-master/equipment-details?client_id=${auth.clientId}&user_id=${auth?.user?.id}&page=&limit=${limit}`,
      auth.accessToken,
    )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          setDropDownEquipmentData(res.data);
        } else {
          ErrorNotify(res.message);
          setDropDownEquipmentData([]);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setDropDownEquipmentData([]);
      });
  };

  const CreateMeterHours = (bodyRequest) => {
    PostApi(
      `equipment/hour-meter-baseline`,
      auth.accessToken,
      JSON.stringify(bodyRequest),
    )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          SuccessNotify("Engine Meter Hours Created successfully");
          setFormData({});
          setShowForm(false);
          setUploadingList([]);
          GetEngineRuntimeData("", 1);
        } else {
          ErrorNotify(res.message);
          setShowLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setShowLoader(false);
      });
  };

  const UpdateMeterHours = (bodyRequest) => {
    UpdateApi(
      `equipment/hour-meter-baseline/${formData.form_id}`,
      auth.accessToken,
      JSON.stringify(bodyRequest),
    )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          SuccessNotify("Engine Meter Hours Updated successfully");
          setFormData({});
          setShowForm(false);
          setUploadingList([]);
          GetEngineRuntimeData("", 1);
        } else {
          ErrorNotify(res.message);
          setShowLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setShowLoader(false);
      });
  };

  const DownloadTemplate = async () => {
    try {
      setShowLoader(true);
      const response = await DownloadFiles(
        `equipment/hour-meter-baseline/template`,
        auth.accessToken,
      );
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Engine_Meter_Runtime_Template.xlsx";
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
      ErrorNotify("Failed to download the template.");
    } finally {
      setShowLoader(false);
    }
  };

  const UploadMeterHoursSheet = () => {
    if (!uploadingList.length) {
      setFormErrors((prev) => ({
        ...prev,
        file: "Please select a file to upload.",
      }));
      ErrorNotify("Please select a file to upload.");
      return;
    }

    const bodyRequestFormData = new FormData();
    bodyRequestFormData.append("client_id", auth.clientId);
    bodyRequestFormData.append("file", uploadingList[0].blobFile);

    setShowLoader(true);
    FormDataPostApi(
      `equipment/hour-meter-baseline/upload`,
      auth.accessToken,
      bodyRequestFormData,
    )
      .then((res) => {
        // Every row is processed independently — valid rows come back with
        // row status 201, conflicts/validation failures with their own error
        // status codes — so surface a per-row breakdown when the API gives us
        // one, and fall back to a plain message otherwise.
        if ([200, 201, 207].includes(res.status)) {
          const rows = Array.isArray(res.results?.data)
            ? res.results.data
            : null;

          if (rows && rows.length) {
            const successCount = rows.filter(
              (row) => row.status === 201 || row.success === true,
            ).length;
            const failedCount = rows.length - successCount;

            if (failedCount > 0) {
              ErrorNotify(
                `${successCount} of ${rows.length} row(s) uploaded. ${failedCount} row(s) failed — please check the file and re-upload those rows.`,
              );
            } else {
              SuccessNotify(`${successCount} row(s) uploaded successfully.`);
            }
          } else {
            SuccessNotify(res.message || "Sheet uploaded successfully");
          }

          setUploadingList([]);
          setShowForm(false);
          setCreateMode("form");
          GetEngineRuntimeData("", 1);
        } else {
          ErrorNotify(res.message || "Failed to upload the sheet.");
          setShowLoader(false);
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorNotify(error);
        setShowLoader(false);
      });
  };

  const handleEdit = (rowData) => {
    setFormData({
      form_id: rowData.id,
      equipment_id: rowData.equnr,
      meter_hours: rowData.meter_hours,
      reason: rowData.reason,
    });
    setFormErrors({});
    setCreateMode("form");
    setShowForm(true);
  };

  return (
    <div className="h-100 w-100 d-flex flex-column bg-light">
      <div className="h-8 w-100 pr-10 d-flex flex-row">
        <Header
          pageName="Engine Meter Runtime"
          backBtn={true}
          isDateRange={false}
        />
        <ToastContainer />
      </div>
      {showLoader ? <ShowLoader></ShowLoader> : null}
      <div className="h-92 pr-10 d-flex flex-column overflow-auto pb-10">
        {/* Row 3: Project Comparison & Cost Optimization */}
        <div className="h-100 project-row">
          <div className="h-100 bg-white p-10 rounded shadow-sm d-flex flex-column flex-grow-1">
            <div className="top-bar">
              {/* Filters Section */}
              <div className="filter-section">
                <div className="filter-item">
                  <InputGroup inside>
                    <Input
                      placeholder="Search..."
                      value={searchKeyword}
                      onChange={(e) => {
                        setPage(1);
                        setLoading(true);

                        if (e.trim() === "") {
                          setSearchKeyword("");
                          GetEngineRuntimeData("", 1);
                        } else {
                          setSearchKeyword(e);
                          GetEngineRuntimeData(e, 1);
                        }
                      }}
                    />
                    <InputGroup.Addon>
                      <SearchIcon />
                    </InputGroup.Addon>
                  </InputGroup>
                </div>
              </div>

              {/* Button Section */}
              <div className="button-section">
                <Button
                  appearance="primary"
                  startIcon={<PlusIcon />}
                  onClick={handleAddNew}
                >
                  Add New
                </Button>
              </div>
            </div>

            <div className="pt-10" style={{ flex: 1, minHeight: 0 }}>
              <Table
                key={`${sortColumn}-${sortType}`}
                fillHeight={true}
                data={filteredData()}
                sortColumn={sortColumn}
                sortType={sortType}
                onSortColumn={handleSortColumn}
                loading={loading}
                bordered
                wordWrap="break-word"
              >
                <Column width={80} align="center" sortable>
                  <HeaderCell>Id</HeaderCell>
                  <Cell dataKey="id" />
                </Column>
                <Column align="center" sortable flexGrow={1} minWidth={150}>
                  <HeaderCell>Equipment</HeaderCell>
                  <Cell dataKey="equnr" />
                </Column>
                <Column flexGrow={1} minWidth={180} align="center" sortable>
                  <HeaderCell>Pre-Meter Hours</HeaderCell>
                  <Cell dataKey="meter_hours" />
                </Column>
                <Column flexGrow={1} minWidth={180} align="center" sortable>
                  <HeaderCell>Reason</HeaderCell>
                  <Cell dataKey="reason" />
                </Column>
                <Column
                  flexGrow={1}
                  minWidth={120}
                  sortable
                  verticalAlign="middle"
                >
                  <HeaderCell>Created At</HeaderCell>
                  <Cell dataKey="created_at">
                    {(rowData) => (
                      <div>
                        {rowData.created_at
                          ? moment(rowData.created_at).format("DD-MM-YYYY")
                          : "-"}
                      </div>
                    )}
                  </Cell>
                </Column>
                <Column
                  flexGrow={1}
                  minWidth={120}
                  sortable
                  verticalAlign="middle"
                >
                  <HeaderCell>Updated At</HeaderCell>
                  <Cell dataKey="updated_at">
                    {(rowData) => (
                      <div>
                        {rowData.updated_at
                          ? moment(rowData.updated_at).format("DD-MM-YYYY")
                          : "-"}
                      </div>
                    )}
                  </Cell>
                </Column>
                <Column
                  flexGrow={1}
                  minWidth={80}
                  align="center"
                  verticalAlign="middle"
                >
                  <HeaderCell>Action</HeaderCell>
                  <Cell dataKey="id" style={{ padding: 0 }}>
                    {(rowData) => {
                      return (
                        <Stack spacing={2} align={"center"}>
                          <IconButton
                            size="sm"
                            appearance="subtle"
                            icon={
                              <EditIcon
                                size={20}
                                style={{ color: "#3f51b5" }}
                              />
                            }
                            onClick={() => handleEdit(rowData)}
                          />
                        </Stack>
                      );
                    }}
                  </Cell>
                </Column>
              </Table>
            </div>

            <div style={{ padding: 10, paddingBottom: 0 }}>
              <Pagination
                prev
                next
                first={!isMobile}
                last={!isMobile}
                ellipsis={!isMobile}
                boundaryLinks
                maxButtons={isMobile ? 3 : 5}
                layout={["total", "-", "pager"]}
                total={totalCount}
                limit={limit}
                activePage={page}
                onChangePage={(e) => {
                  setPage(e);
                  setLoading(true);
                  GetEngineRuntimeData(searchKeyword, e);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Firmware Table POPUP*/}
      <Modal
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setUploadingList([]);
          setCreateMode("form");
        }}
        size="sm"
      >
        <Modal.Header>
          <Modal.Title>Add New Engine Meter Runtime</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {!formData.form_id && (
            <Stack spacing={8} className="mb-10">
              <Button
                size="sm"
                className="uploadBtn"
                appearance={createMode === "form" ? "primary" : "ghost"}
                onClick={() => setCreateMode("form")}
              >
                Fill Form
              </Button>
              <Button
                size="sm"
                className="uploadBtn"
                appearance={createMode === "upload" ? "primary" : "ghost"}
                onClick={() => setCreateMode("upload")}
              >
                Upload Sheet
              </Button>
            </Stack>
          )}

          {createMode === "upload" && !formData.form_id ? (
            <Form fluid>
              <Form.Group>
                <Form.ControlLabel>
                  Upload Sheet (.xlsx, .xls, .csv) *
                </Form.ControlLabel>
                <div className="mb-10">
                  <Button
                    appearance="link"
                    style={{ padding: 0 }}
                    onClick={DownloadTemplate}
                  >
                    Download Template
                  </Button>
                </div>
                <Uploader
                  draggable
                  autoUpload={false}
                  listType="picture-text"
                  multiple={false}
                  fileList={uploadingList}
                  disabled={uploadingList.length >= 1}
                  name="file"
                  accept=".xlsx,.xls,.csv"
                  className="upload-dropzone"
                  onChange={(files) => {
                    clearError("file");
                    setUploadingList(files.slice(0, 1));
                  }}
                  onRemove={() => setUploadingList([])}
                  shouldQueueUpdate={(fileList) => fileList.slice(0, 1)}
                  shouldUpload={() => false}
                  errorPlacement="static"
                  errorMessage={formErrors.file}
                >
                  <div className="upload-dropzone-inner">
                    <FiUploadCloud size={28} className="upload-dropzone-icon" />
                    <div className="upload-dropzone-title">
                      {uploadingList.length
                        ? "File selected"
                        : "Drag & drop your file here"}
                    </div>
                    <div className="upload-dropzone-subtitle">
                      or click to browse &middot; .xlsx, .xls, .csv
                    </div>
                  </div>
                </Uploader>
                <div className="text-muted mt-10" style={{ fontSize: 12 }}>
                  Download the template, fill in the rows, then upload the file
                  to create multiple records at once.
                </div>
              </Form.Group>
            </Form>
          ) : (
            <Form fluid onChange={setFormData} formValue={formData}>
              <Form.Group>
                <Form.ControlLabel>Equipment *</Form.ControlLabel>
                <Form.Control
                  name="equipment_id"
                  accepter={SelectPicker}
                  data={dropDownEquipmentData.map((option) => ({
                    label: `${option.equipment} (${option.description})`,
                    value: option.equipment,
                  }))}
                  searchable={true}
                  style={{ width: "100%" }}
                  errorPlacement="static"
                  errorMessage={formErrors.equipment_id}
                  onChange={(value) => handleChange("equipment_id", value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.ControlLabel>Engine Meter Runtime *</Form.ControlLabel>
                <Form.Control
                  name="meter_hours"
                  placeholder="Enter Engine Meter Runtime"
                  accepter={Input}
                  type="number"
                  errorPlacement="static"
                  errorMessage={formErrors.meter_hours}
                  onChange={(value) => handleChange("meter_hours", value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.ControlLabel>Reason *</Form.ControlLabel>
                <Form.Control
                  name="reason"
                  placeholder="Enter Reason"
                  accepter={Textarea}
                  rows={5}
                  errorPlacement="static"
                  errorMessage={formErrors.reason}
                  onChange={(value) => handleChange("reason", value)}
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            className="CancelBtn"
            onClick={() => {
              setShowForm(false);
              setUploadingList([]);
              setCreateMode("form");
            }}
          >
            Cancel
          </button>
          <Button
            onClick={
              createMode === "upload" && !formData.form_id
                ? UploadMeterHoursSheet
                : handleSubmit
            }
            appearance="primary"
          >
            {createMode === "upload" && !formData.form_id
              ? "Upload"
              : formData.form_id
                ? "Update"
                : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MasterRunninghrs;
